import React from 'react'
import Container from '../container/container'

const Page = () => {
  return (
    <div className='h-screen w-screen flex md:justify-center md:items-center bg-bg'>
        <Container />
    </div>
  )
}

export default Page